(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rating-block-large"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class MultipleUploader {
      #multipleUploader;
      #$imagesUploadInput;

      constructor(selector) {
        this.#multipleUploader = document.querySelector(selector);
        this.#$imagesUploadInput = document.createElement('input');
      }

      init({ maxUpload = 10, maxSize = 2, formSelector = 'form', filesInpName = 'images' } = {}) {
        const form = document.querySelector(formSelector);

        if (!this.#multipleUploader) {
          console.error('Uploader element not found');
          return;
        }

        if (!form) {
          console.error('Form not found:', formSelector);
          return;
        }

        form.enctype = 'multipart/form-data';

        // Setup input
        this.#$imagesUploadInput.type = 'file';
        this.#$imagesUploadInput.name = `${filesInpName}[]`;
        this.#$imagesUploadInput.multiple = true;
        this.#$imagesUploadInput.accept = 'image/*';
        this.#$imagesUploadInput.style.display = 'none';

        form.appendChild(this.#$imagesUploadInput);

        // Click trigger
        this.#multipleUploader.addEventListener('click', (e) => {
          if (e.target.closest('.multiple-uploader')) {
            this.#$imagesUploadInput.click();
          }
        });

        // File change
        this.#$imagesUploadInput.addEventListener('change', (e) => {
          const files = e.target.files;

          if (!files.length) return;

          this.clear();

          const count = Math.min(files.length, maxUpload);

          for (let i = 0; i < count; i++) {
            const file = files[i];
            const size = this.#formatBytes(file.size);

            const isValid = this.#isValidSize(size, maxSize);

            const html = `
            <div class="image-container" data-index="${i}" data-valid="${isValid}">
              <div class="image-size">${size.size} ${size.unit}</div>
              ${!isValid ? `<div class="exceeded-size">Max ${maxSize} MB</div>` : ''}
              <img src="${URL.createObjectURL(file)}" class="image-preview" />
            </div>
          `;

            this.#multipleUploader.insertAdjacentHTML('beforeend', html);

            if (!isValid) this.#removeFile(i);
          }

          this.#multipleUploader.querySelector('.mup-msg')?.style.setProperty('display', 'none');
        });

        // Remove image
        document.addEventListener('click', (e) => {
          const container = e.target.closest('.image-container');
          if (!container) return;

          const index = container.dataset.index;
          const isValid = container.dataset.valid === 'true';

          container.remove();

          if (isValid) this.#removeFile(index);

          if (!document.querySelector('.image-container')) {
            this.clear();
          }

          this.#reorder();
        });

        return this;
      }

      clear() {
        this.#multipleUploader.querySelectorAll('.image-container').forEach((el) => el.remove());
        this.#multipleUploader.querySelector('.mup-msg')?.style.setProperty('display', 'flex');
        this.#$imagesUploadInput.value = '';
      }

      #removeFile(indexToRemove) {
        const dt = new DataTransfer();

        Array.from(this.#$imagesUploadInput.files).forEach((file, index) => {
          if (index != indexToRemove) dt.items.add(file);
        });

        this.#$imagesUploadInput.files = dt.files;
      }

      #reorder() {
        document.querySelectorAll('.image-container').forEach((el, index) => {
          el.dataset.index = index;
        });
      }

      #isValidSize(size, maxSize) {
        return size.unit !== 'MB' || parseFloat(size.size) <= maxSize;
      }

      #formatBytes(bytes) {
        const sizes = ['Bytes', 'KB', 'MB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return {
          size: i === 0 ? bytes : (bytes / Math.pow(1024, i)).toFixed(1),
          unit: sizes[i],
        };
      }
    }

    // INIT
    window.addEventListener('load', () => {
      new MultipleUploader('#multiple-uploader').init({
        maxUpload: 10,
        maxSize: 5,
        filesInpName: 'photos',
        formSelector: '#rating-form',
      });

      // Dialog handling (Fallback; das Modul-JS uebernimmt Oeffnen/Schliessen + Submit)
      const dialog = document.querySelector('.myharry-rating-large__dialog');
      const openBtn = document.querySelector('.myharry-rating-large__add-review-btn');
      const closeBtn = document.querySelector('.myharry-rating-large__close-btn');

      openBtn?.addEventListener('click', () => {
        if (dialog && !dialog.open) dialog.showModal();
      });
      closeBtn?.addEventListener('click', () => {
        if (dialog && dialog.open) dialog.close();
      });

      dialog?.addEventListener('click', (e) => {
        if (e.target === dialog && dialog.open) dialog.close();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
